import IndexVM from './index-vm';
export default {
  init: function(node){
    console.log('Kadenze.ForumThreadListing initialization function called');

    let forum_data = JSON.parse($('#forums_json').val());
    let validationOpts = _.extend({}, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS, {insertMessages: false});
    let vm = new IndexVM(forum_data);
    ko.applyBindingsWithValidation(vm, node, validationOpts);
  }
};
